<template>
  <div>
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="data-table-title">
      <div class="data-table-description"></div>
      <el-tooltip :disabled="ig_info.length < ig_connect_limit">
        <div slot="content">連携可能なアカウント数の上限に達しています</div>
        <span>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="ig_info.length >= ig_connect_limit ? '' : openLoginDrawer()"
            :disabled="ig_info.length >= ig_connect_limit"
            >新規アカウント連携</el-button
          >
        </span>
      </el-tooltip>
    </div>
    <!-- <div class="data-table-th-loading" v-loading="loading" v-if="loading"></div> -->
    <div class="data-table-list-nolist" v-if="ig_info.length == 0">
      <img src="../../assets/chat_image.png" style="opacity: 0.5" alt />
      <div style="font-size: 20px; font-weight: 700; margin-bottom: 15px">
        Instagramアカウントが連携されていません
      </div>
      <div class="data-table-list-nolist-content">
        メッセージの送受信を行うには連携を行ってください。
      </div>
      <el-button type="primary" @click="openLoginDrawer()" icon="el-icon-plus"
        >新規アカウント連携</el-button
      >
    </div>

    <div class="setting-wrap" v-if="ig_info.length > 0">
      <div class="wrap-title">
        連携済みのアカウント({{ ig_info.length }}/{{ ig_connect_limit }})
      </div>
      <div class="setting-subwrap top">
        <div class="setting-member-wrap">
          <div
            class="setting-member-user connect"
            v-for="ig_info in ig_connect_single_sender"
            :key="ig_info.id"
          >
            <el-tooltip
              :disabled="
                ig_info.ig_id == ig_selected.ig_id ||
                ig_info.login_required == 1
              "
              placement="top"
            >
              <div slot="content">アカウントの切り替え</div>
              <div
                class="setting-member-image connect"
                :class="
                  ig_info.ig_id == ig_selected.ig_id || ig_info.login_required
                    ? 'select'
                    : ''
                "
                @click="ig_info.login_required ? '' : changeIGAccount(ig_info)"
              >
                <el-image
                  :src="
                    s3BaseUrl + '/profile_picture/' +
                    ig_info.account_name +
                    '.jpg'
                  "
                  class="setting-member-profile"
                  :style="ig_info.login_required ? 'opacity:0.5' : ''"
                >
                  <div slot="error" class="data-table-profile-noimg">
                    NO<br />IMAGE
                  </div>
                </el-image>
                <div
                  class="connect-selected-icon"
                  v-if="ig_info.account_name == ig_selected.account_name"
                >
                  <font-awesome-icon :icon="['fas', 'check']" />
                </div>
                <div class="connect-error" v-if="ig_info.login_required">
                  <font-awesome-icon :icon="['fas', 'exclamation']" />
                </div>
              </div>
            </el-tooltip>
            <div
              class="setting-member-name connect"
              :style="ig_info.login_required ? 'opacity:0.5' : ''"
            >
              <span>{{ ig_info.account_name }}</span>
            </div>
            <div
              class="ig-selected-login-required"
              v-if="ig_info.login_required"
            >
              連携が解除されています
            </div>
            <div class="setting-member-edit connect">
              <el-button
                v-if="ig_info.login_required"
                type="primary"
                size="mini"
                @click="relogin(ig_info.account_name)"
                style="margin-top: 10px; width: 100%"
                >再連携</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="logout(ig_info.account_name)"
                style="margin-left: 0px; margin-top: 10px; width: 100%"
                >連携を解除</el-button
              >
              <el-button
                v-if="
                  ig_info.sender_type === 1 &&
                  !ig_info.login_required &&
                  admin_mode
                "
                type="success"
                size="mini"
                @click="
                  changeSenderType(ig_info.account_name, ig_info.sender_type)
                "
                style="margin-left: 0px; margin-top: 10px; width: 100%"
                >一斉送信に使用</el-button
              >
            </div>
          </div>
          <el-tooltip :disabled="ig_info.length < ig_connect_limit">
            <div slot="content">連携可能なアカウント数の上限に達しています</div>
            <div
              class="setting-member-add account"
              @click="
                ig_info.length >= ig_connect_limit ? '' : openLoginDrawer()
              "
            >
              <font-awesome-icon icon="plus" />
              <div class="setting-member-add-description">アカウントを追加</div>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="inbox-login-wait">
        アカウントの連携状態を維持するには
        <span class="router-link" @click="after_login_later = true">こちら</span
        >をご確認ください。
      </div>
    </div>

    <!-- 一斉送信用アカウント一覧 -->
    <div
      class="setting-wrap"
      v-if="ig_connect_bulk_sender.length > 0 && admin_mode"
    >
      <div class="wrap-title">
        メッセージ一斉送信用アカウント ({{ ig_connect_bulk_sender.length }}/{{
          ig_connect_limit
        }})
      </div>
      <div class="setting-subwrap top">
        <div class="setting-member-wrap">
          <div
            class="setting-member-user connect"
            v-for="ig_info in ig_connect_bulk_sender"
            :key="ig_info.id"
          >
            <el-tooltip disabled>
              <div class="setting-member-image connect">
                <el-image
                  :src="
                    s3BaseUrl + '/profile_picture/' +
                    ig_info.account_name +
                    '.jpg'
                  "
                  class="setting-member-profile"
                  :style="ig_info.login_required ? 'opacity:0.5' : ''"
                >
                  <div slot="error" class="data-table-profile-noimg">
                    NO<br />IMAGE
                  </div>
                </el-image>
                <div class="connect-error" v-if="ig_info.login_required">
                  <font-awesome-icon :icon="['fas', 'exclamation']" />
                </div>
              </div>
            </el-tooltip>
            <div
              class="setting-member-name connect"
              :style="ig_info.login_required ? 'opacity:0.5' : ''"
            >
              <span>{{ ig_info.account_name }}</span>
            </div>
            <div
              class="ig-selected-login-required"
              v-if="ig_info.login_required"
            >
              連携が解除されています
            </div>
            <div class="setting-member-edit connect">
              <el-button
                v-if="ig_info.login_required"
                type="primary"
                size="mini"
                @click="relogin(ig_info.account_name)"
                style="margin-top: 10px; width: 100%"
                >再連携</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="logout(ig_info.account_name)"
                style="margin-left: 0px; margin-top: 10px; width: 100%"
                >連携を解除</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="
                  changeSenderType(ig_info.account_name, ig_info.sender_type)
                "
                style="margin-left: 0px; margin-top: 10px; width: 100%"
                >一斉送信を解除</el-button
              >
            </div>
          </div>
          <el-tooltip :disabled="ig_info.length < ig_connect_limit">
            <div slot="content">連携可能なアカウント数の上限に達しています</div>
            <div
              class="setting-member-add account"
              @click="
                ig_info.length >= ig_connect_limit
                  ? ''
                  : openBulkSenderLoginDrawer()
              "
            >
              <font-awesome-icon icon="plus" />
              <div class="setting-member-add-description">アカウントを追加</div>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="inbox-login-wait">
        こちらに登録されたアカウントは、メッセージ送信時に「一斉送信アカウント」を選択した際の送信元リストとなります。<br />
        大量のメッセージを送信する際には順次設定されます。
      </div>
    </div>

    <!-- Loing Dialog -->
    <transition name="fade">
      <div class="phrase-overlay" v-if="login_drawer">
        <div class="create-phrase-wrap">
          <div class="list-create">
            <div class="newmessage-title">
              新規アカウント連携
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="login_drawer = false">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div style="margin: 30px 0">
              <ul class="ul-exclamation">
                <li>
                  アカウント連携には、<span style="font-weight: bold;" >事前にInstagram側でSMS認証またはアプリ認証による二段階認証の設定が必要</span>です。<br>
                  SMS認証・アプリ認証の設定を併用している場合、アプリ認証が優先されます。<br>
                  未設定の場合、連携ができませんのでご注意ください。詳しい設定方法は<a href="https://help.reech.co.jp/ja/articles/10152434-instagram%E3%82%A2%E3%82%AB%E3%82%A6%E3%83%B3%E3%83%88%E3%81%8C%E9%80%A3%E6%90%BA%E3%81%A7%E3%81%8D%E3%81%AA%E3%81%84" target="_blank" class="router-link" >こちら</a>をご参照ください。
                </li>
                <li>
                  アカウント連携時に「普段使用しているものとは異なるデバイスから不審なログインがありました。」という旨の通知が普段使用しているアプリ内およびメールに届く場合がございます。上記内容の通知は{{ siteName }}
                  からのログインとなりますので、承認いただきますようお願いいたします。
                </li>
                <li>
                  Instagramの規制を無視してDMの送信を続けるなどの行為を行なった場合、アカウントが停止・制限・凍結する可能性がございます。本サービスに連携いただいたアカウントが停止・制限・凍結した場合でも、当社は責任を負わないものとします。
                </li>
                <li>
                  その他ログインやDM送信が上手くいかない場合は<a href="https://help.reech.co.jp/ja/collections/3129689-dm%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6" target="_blank" class="router-link" >こちら</a>をご確認ください。
                </li>
              </ul>
            </div>
            <div class="list-create-box connect">
              <div class="list-create-name">ユーザー名</div>
              <el-input
                v-model="account_name"
                autocomplete="off"
                type="text"
              ></el-input>
            </div>
            <div class="list-create-box">
              <div class="list-create-name">パスワード</div>
              <el-input
                v-model="password"
                show-password
                autocomplete="new-password"
                @keydown.enter.native="login()"
              ></el-input>
            </div>

            <div class="list-create-footer">
              <transition name="fade">
                <div
                  v-if="login_wait && login_loading"
                  class="inbox-login-wait"
                >
                  連携には最大で60秒程度時間がかかる場合があります
                </div>
              </transition>
              <div class="flex-space"></div>
              <el-button
                :disabled="login_loading"
                @click="login_loading ? '' : (login_drawer = false)"
                >キャンセル</el-button
              >
              <el-button
                type="primary"
                native-type="submit"
                :disabled="login_loading || !account_name || !password"
                @click="login()"
              >
                <div class="flex-row">
                  上記注意事項に同意して連携する
                  <div class="loader--mini" v-show="login_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 再連携 -->
    <transition name="fade">
      <div class="phrase-overlay" v-if="relogin_drawer">
        <div class="create-phrase-wrap">
          <div class="list-create">
            <div class="newmessage-title">
              アカウント再連携
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="relogin_drawer = false">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div class="list-create-box connect">
              <div class="list-create-name">ユーザー名</div>
              <el-input
                v-model="account_name"
                disabled
                autocomplete="off"
                type="text"
              ></el-input>
            </div>
            <div class="list-create-box">
              <div class="list-create-name">パスワード</div>
              <el-input
                v-model="password"
                show-password
                autocomplete="new-password"
                @keydown.enter.native="login()"
              ></el-input>
            </div>

            <div class="list-create-footer">
              <transition name="fade">
                <div
                  v-if="login_wait && login_loading"
                  class="inbox-login-wait"
                >
                  連携には最大で60秒程度時間がかかる場合があります
                </div>
              </transition>
              <div class="flex-space"></div>
              <el-button
                :disabled="login_loading"
                @click="login_loading ? '' : (relogin_drawer = false)"
                >キャンセル</el-button
              >
              <el-button
                type="primary"
                native-type="submit"
                :disabled="login_loading || !account_name || !password"
                @click="login()"
              >
                <div class="flex-row">
                  再連携する
                  <div class="loader--mini" v-show="login_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- bulk sender Loing Dialog -->
    <transition name="fade">
      <div class="phrase-overlay" v-if="bulk_sender_login_drawer">
        <div class="create-phrase-wrap">
          <div class="list-create">
            <div class="newmessage-title">
              メッセージ一斉送信用アカウント連携
              <div class="flex-space"></div>
              <div
                class="newmessage-button"
                @click="bulk_sender_login_drawer = false"
              >
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div style="margin: 30px 0">
              <ul class="ul-exclamation">
                <li>
                  アカウント連携時に「普段使用しているものとは異なるデバイスから不審なログインがありました。」という旨の通知が普段使用しているアプリ内およびメールに届く場合がございます。上記内容の通知は{{ siteName }}
                  からのログインとなりますので、承認いただきますようお願いいたします。
                </li>
                <li>
                  Instagramの規制を無視してDMの送信を続けるなどの行為を行なった場合、アカウントが停止・制限・凍結する可能性がございます。本サービスに連携いただいたアカウントが停止・制限・凍結した場合でも、当社は責任を負わないものとします。
                </li>
              </ul>
            </div>
            <div class="list-create-box connect">
              <div class="list-create-name">ユーザー名</div>
              <el-input
                v-model="account_name"
                autocomplete="off"
                type="text"
              ></el-input>
            </div>
            <div class="list-create-box">
              <div class="list-create-name">パスワード</div>
              <el-input
                v-model="password"
                show-password
                autocomplete="new-password"
                @keydown.enter.native="login(false, 3)"
              ></el-input>
            </div>

            <div class="list-create-footer">
              <transition name="fade">
                <div
                  v-if="login_wait && login_loading"
                  class="inbox-login-wait"
                >
                  連携には最大で60秒程度時間がかかる場合があります
                </div>
              </transition>
              <div class="flex-space"></div>
              <el-button
                :disabled="login_loading"
                @click="login_loading ? '' : (bulk_sender_login_drawer = false)"
                >キャンセル</el-button
              >
              <el-button
                type="primary"
                native-type="submit"
                :disabled="login_loading || !account_name || !password"
                @click="login(false, 3)"
              >
                <div class="flex-row">
                  上記注意事項に同意して連携する
                  <div class="loader--mini" v-show="login_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- <div class="setting-wrap instagram">
      <div class="wrap-title">Instagramアカウント連携</div>
      <div v-if="!sessionid || " style="width:100%">
        <div style="margin-top:30px">
          アカウント連携時に「普段使用しているものとは異なるデバイスから不審なログインがありました。」という旨の通知が普段使用しているアプリ内およびメールに届く場合がございます。
          <br />上記内容の通知はREECH DATABASEからのログインとなりますので、承認いただきますようお願いいたします。
        </div>
        <div class="setting-subwrap top">
          <div class="setting-subtitle">ユーザー名</div>
          <el-input style="margin-bottom:15px" v-model="account_name" autocomplete="off" type="text"></el-input>
        </div>
        <div class="setting-subwrap">
          <div class="setting-subtitle">パスワード</div>
          <el-input v-model="password" show-password autocomplete="new-password" style="margin-bottom:15px" @keydown.enter="login()"></el-input>
        </div>
        <div class="divider-nomargin"></div>
        <div class="inbox-buttonarea">
          <el-button type="primary" native-type="submit" style="margin-right:20px" :disabled="login_loading || !account_name || !password" @click="login()">
            連携する
            <font-awesome-icon :icon="['fas', 'spinner-third']" spin style="margin-left:5px" v-show="login_loading" />
          </el-button>
          <transition name="fade">
            <div v-if="login_wait && login_loading" class="inbox-login-wait">ログインには最大で60秒程度時間がかかる場合があります</div>
          </transition>
        </div>
      </div>
      <div v-if="sessionid && !" class="inbox-account-setting">
        <div class="inbox-account-setting-account">
          <el-image v-bind:src="ig_info.profile_picture_url" class="inbox-profile">
            <div slot="error" class="data-table-profile-noimg">
              NO
              <br />IMAGE
            </div>
          </el-image>
          <div class="inbox-account-setting-profile">
            <div class="inbox-account-setting-name">{{ ig_info.account_name }}</div>
            <div class="inbox-account-setting-connect"><font-awesome-icon class="inbox-account-setting-check" :icon="['fas', 'check-circle']" />連携中</div>
          </div>
          <div class="flex-space"></div>
          <el-button type="primary">アカウント切り替え</el-button>
          <el-button type="primary" @click="logout()" :disabled="logout_loading">
            連携解除
            <font-awesome-icon :icon="['fas', 'spinner-third']" spin style="margin-left:5px" v-show="logout_loading" />
          </el-button>
        </div>
        <div class="inbox-login-wait" style="margin-top: 30px;">
          アカウントの連携状態を維持するには
          <span class="router-link" @click="after_login = true">こちら</span>をご確認ください。
        </div>
      </div>

    </div> -->

    <!-- チャレンジ -->
    <div>
      <div
        class="phrase-overlay"
        :style="
          challenge_drawer ? 'z-index:300010' : 'z-index:-30000; opacity:0'
        "
      >
        <transition name="fade">
          <div class="create-phrase-wrap" v-if="challenge_drawer">
            <div class="newmessage-title">
              普段お使いのデバイスでログインを承認してください
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="challenge_drawer = false">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div class="list-create-box challenge">
              <img
                src="../../assets/instagram-challenge.jpeg"
                class="challenge-image"
              />
              <div style="margin-left: 20px">
                普段お使いのデバイスでInstagramアカウントにアクセスしてください。
                <br />左画像のような画面が表示されますので、「私です」もしくは「私が実行したものである」をクリックし、ログインを承認して下さい。
                <br />ログイン承認後、下記の再ログインをクリックしてください。
                <br />
                <br />アカウントの状況により、3~4回ほど承認フローを繰り返していただく場合がございます。それでもログインできない場合、
                <span class="router-link" @click="inquiry()">こちら</span
                >よりお問い合わせください。
              </div>
            </div>

            <div class="list-create-footer">
              <transition name="fade">
                <div
                  v-if="login_wait && challenge_loading"
                  class="inbox-login-wait"
                >
                  再連携には最大で1~2分程度時間がかかる場合があります。しばらくお待ちください。
                </div>
              </transition>
              <div class="flex-space"></div>
              <el-button
                :disabled="challenge_loading"
                @click="challenge_drawer = false"
                >キャンセル</el-button
              >
              <el-button type="primary" @click="login(true)">
                <div class="flex-row">
                  再ログイン
                  <div class="loader--mini" v-show="challenge_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- Two Factor -->
    <transition name="fade">
      <div class="phrase-overlay" v-if="two_factor_drawer">
        <div class="create-phrase-wrap">
          <div class="list-create">
            <div class="newmessage-title">
              セキュリティコードの入力
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="two_factor_drawer = false">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div>
              <span>このアカウントには2段階認証が設定されています。</span><br />
              <span v-if="two_factor_info.totp_two_factor_on"
                >認証アプリに</span
              >
              <span v-else-if="two_factor_info.whatsapp_two_factor_on"
                >WhatsAppに</span
              >
              <span v-else-if="two_factor_info.sms_two_factor_on"
                >電話番号(下4桁:{{
                  two_factor_info.obfuscated_phone_number
                }})に</span
              >
              送信されたコードを入力してください。
            </div>
            <div class="list-create-box" style="margin-top: 20px">
              <div class="list-create-name">セキュリティコード</div>
              <el-input
                v-model="verification_code"
                autocomplete="off"
                type="text"
              ></el-input>
            </div>

            <div class="list-create-footer">
              <transition name="fade">
                <div
                  v-if="login_wait && login_loading"
                  class="inbox-login-wait"
                >
                  連携には最大で60秒程度時間がかかる場合があります
                </div>
              </transition>
              <div class="flex-space"></div>
              <el-button
                :disabled="login_loading"
                @click="login_loading ? '' : (two_factor_drawer = false)"
                >キャンセル</el-button
              >
              <el-button
                type="primary"
                native-type="submit"
                :disabled="login_loading || !verification_code"
                @click="loginTwoFactor()"
              >
                <div class="flex-row">
                  実行
                  <div class="loader--mini" v-show="login_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- ログイン成功 -->
    <div
      class="phrase-overlay"
      :style="
        after_login || after_login_later
          ? 'z-index:300010'
          : 'z-index:-30000; opacity:0'
      "
    >
      <transition name="fade">
        <div class="create-phrase-wrap" v-if="after_login || after_login_later">
          <div class="newmessage-title">
            <font-awesome-icon
              :icon="['fas', 'check-circle']"
              style="margin-right: 15px; color: #27b933; font-size: 24px"
              v-if="after_login"
            />
            <span v-if="after_login">
              Instagramアカウント連携が完了しました
            </span>
            <span v-else> アカウント連携状態の維持 </span>
            <div class="flex-space"></div>
            <div
              class="newmessage-button"
              @click="(after_login = false), (after_login_later = false)"
            >
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>
          <div class="list-create-box challenge">
            <div style="margin-left: 20px; line-height: 1.8">
              Instagramの仕様上、アカウント連携は数日程度で解除されてしまいます。
              <br />アカウント連携を維持するためには、普段お使いのデバイスで今回のログインを承認してください。
              <br />
              <br />
              <strong>
                <font-awesome-icon
                  :icon="['fal', 'exclamation-circle']"
                />ログインの承認方法
              </strong>
              <br />
              <ol class="login-after-step">
                <li>
                  普段お使いのデバイスで
                  <strong>
                    [<font-awesome-icon :icon="['far', 'cog']" />設定 ] </strong
                  >を開きます
                </li>
                <li>
                  <strong
                    >[
                    <font-awesome-icon
                      :icon="['far', 'shield-check']"
                    />セキュリティ]
                  </strong>
                  →
                  <strong
                    >[
                    <font-awesome-icon
                      :icon="['far', 'map-marker-alt']"
                    />ログインアクティビティ] </strong
                  >を開きます
                </li>
                <li>
                  <strong>[あなたが実行したものですか？]</strong
                  >の文章とともにログインアクティビティが表示されます
                </li>
                <li>
                  最も新しいログイン情報の
                  <strong>[私です]</strong
                  >をタップしてログインを承認してください
                </li>
              </ol>
            </div>
          </div>

          <div class="list-create-footer">
            <el-button
              type="primary"
              @click="(after_login = false), (after_login_later = false)"
              >閉じる</el-button
            >
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

const root = process.env.VUE_APP_API;
const loginAPI = root + "/api/message/login";
const loginTwoFactorAPI = root + "/api/message/login_two_factor";
const logoutAPI = root + "/api/message/logout";
const updateAPI = root + "/api/message/update";

export default {
  name: "connect",
  props: [""],
  components: {
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      account_name: "",
      password: "",
      requestId: 0,
      login_drawer: false,
      bulk_sender_login_drawer: false,
      login_response: [],
      login_loading: false,
      login_wait: false,
      logout_loading: false,
      relogin_drawer: false,
      challenge_drawer: false,
      challenge_loading: false,
      after_login: false,
      after_login_later: false,
      two_factor_drawer: false,
      two_factor_info: [],
      verification_code: "",
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    ig_connect_limit() {
      return this.$store.state.ig_connect_limit;
    },
    ig_connect_single_sender: function () {
      return this.ig_info.filter(function (info) {
        return info.sender_type === 1 || info.sender_type === 2;
      });
    },
    ig_connect_bulk_sender: function () {
      return this.ig_info.filter(function (info) {
        return info.sender_type === 2 || info.sender_type === 3;
      });
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
  },
  mounted() {},
  methods: {
    openLoginDrawer() {
      this.login_drawer = true;
    },
    openBulkSenderLoginDrawer() {
      this.bulk_sender_login_drawer = true;
    },
    login(challenge, sender_type = 1) {
      if (challenge) {
        this.challenge_loading = true;
      } else {
        this.login_loading = true;
      }

      setTimeout(() => {
        this.login_wait = true;
      }, 5000);
      if (this.account_name.match(/@|＠/)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "メールアドレスではログインできません",
        });
        this.login_wait = false;
        this.login_loading = false;
      } else {
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("account_name", this.account_name);
        params.append("password", this.password);
        params.append("challenge", challenge ? true : false);
        params.append("sender_type", sender_type);
        this.axios
          .post(loginAPI, params)
          .then((response) => {
            if (response.data.status == "OK") {
              if (response.data.auth_type == "two_factor_required") {
                this.login_drawer = false;
                this.bulk_sender_login_drawer = false;
                this.relogin_drawer = false;
                this.challenge_drawer = false;
                this.two_factor_info = response.data.two_factor_info;
                this.two_factor_drawer = true;
                this.login_loading = false;
                this.login_wait = false;
              } else {
                //Instagramログイン情報をstoreに保存
                this.$store
                  .dispatch("getUserData", {
                    token: this.token,
                    user_token: this.user_token,
                  })
                  .then(() => {
                    setTimeout(() => {
                      // this.loadInbox();
                      this.login_drawer = false;
                      this.bulk_sender_login_drawer = false;
                      this.relogin_drawer = false;
                      this.after_login = true;
                      this.login_loading = false;
                      this.login_wait = false;
                      if (challenge) {
                        this.challenge_loading = false;
                        this.challenge_drawer = false;
                      }
                      if (sender_type === 1) {
                        this.$store.dispatch(
                          "changeIGAccount",
                          response.data.ig_info
                        );
                        this.account_name = "";
                        this.password = "";
                      }
                    }, 3000);
                  });
              }
            } else {
              if (response.data.error_type == "challenge_required") {
                this.challenge_drawer = true;
                if (challenge) {
                  this.challenge_loading = false;
                }
              } else {
                this.$message({
                  type: "error",
                  offset: 7,
                  duration: 0,
                  showClose: true,
                  message: response.data.message,
                });
              }
              this.login_wait = false;
              this.login_loading = false;
            }
          })
          .catch(() => {
            if (challenge) {
              this.challenge_loading = false;
              this.challenge_drawer = false;
            }
          });
      }
    },
    loginTwoFactor() {
      this.login_loading = true;
      setTimeout(() => {
        this.login_wait = true;
      }, 5000);
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("account_name", this.two_factor_info.username);
      params.append(
        "two_factor_identifier",
        this.two_factor_info.two_factor_identifier
      );
      params.append("verification_code", this.verification_code);
      params.append(
        "totp_two_factor_on",
        this.two_factor_info.totp_two_factor_on
      );
      this.axios
        .post(loginTwoFactorAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            //Instagramログイン情報をstoreに保存
            this.$store
              .dispatch("getUserData", {
                token: this.token,
                user_token: this.user_token,
              })
              .then(() => {
                setTimeout(() => {
                  this.two_factor_drawer = false;
                  this.after_login = true;
                  this.login_loading = false;
                  this.login_wait = false;
                  this.$store.dispatch(
                    "changeIGAccount",
                    response.data.ig_info
                  );
                }, 3000);
              });
          } else {
            if (response.data.error_type == "challenge_required") {
              this.two_factor_drawer = false;
              this.challenge_drawer = true;
            } else if (response.data.error_type == "two_factor_required") {
              this.two_factor_info = response.data.two_factor.two_factor_info;
              this.two_factor_drawer = true;
            } else {
              this.$message({
                type: "error",
                offset: 7,
                duration: 0,
                showClose: true,
                message: response.data.message,
              });
            }
            this.login_wait = false;
            this.login_loading = false;
            this.verification_code = "";
          }
        })
        .catch(() => {});
    },
    logout(account_name) {
      this.$alert(
        "連携を解除すると過去メッセージの再送信は行えなくなります。",
        "アカウント連携解除",
        {
          confirmButtonText: "連携解除",
          confirmButtonClass: "danger",
          showCancelButton: true,
          cancelButtonText: "キャンセル",
          type: "warning",
        }
      ).then(() => {
        this.logout_loading = true;
        this.$message({
          type: "info",
          duration: 0,
          offset: 7,
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: '連携を解除中です<div class="loader--mini"></div>',
        });
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("account_name", account_name);
        this.axios
          .post(logoutAPI, params)
          .then((response) => {
            if (response.data.status == "ok") {
              //Instagramログイン情報をstoreに保存
              this.$store
                .dispatch("getUserData", {
                  token: this.token,
                  user_token: this.user_token,
                })
                .then(() => {
                  if (this.ig_selected.account_name == account_name) {
                    this.$store.dispatch("changeIGAccount", []);
                  }
                });
              this.$message.closeAll();
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "連携を解除しました",
              });
              this.logout_loading = false;
            } else {
              this.logout_loading = false;
              this.$message.closeAll();
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: "連携解除に失敗しました",
                duration: 0,
              });
            }
          })
          .catch(() => {
            this.$message.closeAll();
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "連携解除に失敗しました",
              duration: 0,
            });
          });
      });
    },
    relogin(account_name) {
      this.account_name = account_name;
      this.relogin_drawer = true;
    },
    changeIGAccount(value) {
      this.$store.dispatch("changeIGAccount", value);
    },
    changeSenderType(account_name, sender_type) {
      var alert_message, alert_title, alert_button, update_sender_type;
      if (sender_type === 1) {
        alert_message = "このアカウントを一斉送信用として使用します";
        alert_title = "一斉送信用アカウントに登録";
        alert_button = "登録";
        update_sender_type = 2;
      } else {
        alert_message = "このアカウントを一斉送信用から解除します";
        alert_title = "一斉送信用アカウントから削除";
        alert_button = "削除";
        update_sender_type = 1;
      }
      this.$alert(alert_message, alert_title, {
        confirmButtonText: alert_button,
        confirmButtonClass: "success",
        showCancelButton: true,
        cancelButtonText: "キャンセル",
        type: "warning",
      }).then(() => {
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("account_name", account_name);
        params.append("sender_type", update_sender_type);
        this.axios
          .post(updateAPI, params)
          .then((response) => {
            if (response.data.status == "OK") {
              this.$store
                .dispatch("getUserData", {
                  token: this.token,
                  user_token: this.user_token,
                })
                .then(() => {
                  if (this.ig_selected.account_name == account_name) {
                    this.$store.dispatch("changeIGAccount", []);
                  }
                });
              this.$message.closeAll();
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "一斉送信用アカウントに設定しました",
              });
            } else {
              this.logout_loading = false;
              this.$message.closeAll();
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: "一斉送信用アカウントへの設定に失敗しました",
                duration: 0,
              });
            }
          })
          .catch(() => {
            this.$message.closeAll();
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "一斉送信用アカウントへの設定に失敗しました",
              duration: 0,
            });
          });
      });
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
};
</script>
